import { FileDiv, InnerFiles, MeetingVideoDiv, NoMessage } from "./style";
import {
  AiOutlineFileExcel,
  AiOutlineFileImage,
  AiOutlineFilePdf,
  AiOutlineFileWord,
} from "react-icons/ai";
import { BsFillFileEarmarkImageFill } from "react-icons/bs";
import { FaRegFileAudio, FaRegFileVideo } from "react-icons/fa";
import { MdOutlineFilePresent } from "react-icons/md";
import { VscJson } from "react-icons/vsc";
import { BASE_URL } from "../../../../constants";
import { useMutation, useQuery } from "react-query";
import { QUERIES_NAME } from "../../../../constants/apiqueries";
import { useParams } from "react-router-dom";
import { API } from "../../../../services/api";
import { Box, CircularProgress } from "@mui/material";
import React, { useContext, useEffect } from "react";
import { AgendaContext } from "../../pages/MeetingDetails/context/MeetingDetailContext";
import { useTranslation } from "react-i18next";
import { DeleteIcon, PlusIcon } from "../../../../assets/icons";
import { MyButton } from "../../../../components";
import { green } from "@mui/material/colors";
import { toast } from "react-toastify";
import { useState } from "react";

function MeetingVideos() {
  const [deletFileId, setDeleteFileId] = useState(null);
  const [meetingVideos, setMeetingVideos] = useState([]);
  const [meetingVideo, setMeetingVideo] = useState(null);
  const [isLoading, setLoading] = useState(false);

  const { meetingId } = useParams();
  const { t } = useTranslation();
  const {
    data: meetingFiles,
    refetch,
  } = useQuery([QUERIES_NAME.MEETING_VIDEO], async () => {
    const response =  await API.getAllMeetingVideoByMeetingId({ meetingId })
      .then((res) => res.data)
      .catch((err) => console.log(err));
    return response;
  });

  const deleteMeetingVideo = async(id) => {
    setLoading(true);
    const response = await API.deleteMeetingVideo(id)
    .then((res) => {
      setLoading(false);
        toast.success("File muvafaqiyarli o'chirildi");
        refetch();
    })
    .catch((err) => {
      setLoading(false);
      toast.error("File O'chirilmadi")
  })
  }

 

  const { mutate: agendaFileCreate, isLoading: agendaFileCreateLoading } =
  useMutation(async () => {
    const fileData = new FormData();
    console.log(meetingId, 'ID собрания');

    if (meetingVideo) {
      fileData.append("file", meetingVideo);
      fileData.append("meetingId", meetingId);

      // Логируем содержимое FormData
      for (let [key, value] of fileData.entries()) {
        console.log(`${key}: ${value}`);
      }

      return await API.uploadMeetingVideo(fileData)
        .then((res) => {
          toast.success("Файл загружен");
          refetch();
        })
        .catch((err) => {
          toast.error("Файл не загружен");
        });
    } else {
      console.error("Файл не выбран");
    }
  });

    const handleFileChange = (e) => {
      const files = e.target.files;
      if (files.length > 0) {
        setMeetingVideo(files[0]);
        agendaFileCreate();
      }
    };


  const downloadFile = ({ fileId, name }) => {
    const token = localStorage.getItem("token");
    fetch(BASE_URL + "/meeting/upload-meeting-video/" + fileId, {
      method: "GET",
      headers: {
        Authorization: token,
      },
    })
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(new Blob([blob]));

        const link = document.createElement("a");
        link.href = url;
        link.download = name;

        document.body.appendChild(link);

        link.click();

        link.parentNode.removeChild(link);
      });
  };

  function fileTypeIcon(type) {
    const excel =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const word =
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
    const presentation =
      "application/vnd.openxmlformats-officedocument.presentationml.presentation";
    const jsonFile = "application/json";
    const pdf = "application/pdf";
    const video = "video/mp4";
    const audioMpeg = "audio/mpeg";
    const image = "image/jpeg";
    const imgPNG = "image/png";

    if (type === excel) {
      return <AiOutlineFileExcel fontSize={30} className="text-success" />;
    } else if (type === word) {
      return <AiOutlineFileWord fontSize={30} style={{ color: "#132e85" }} />;
    } else if (type === pdf) {
      return <AiOutlineFilePdf fontSize={30} className="text-danger" />;
    } else if (type === imgPNG) {
      return <BsFillFileEarmarkImageFill fontSize={30} className="text-info" />;
    } else if (type === image) {
      return <AiOutlineFileImage fontSize={30} style={{ color: "#132e85" }} />;
    } else if (type === video) {
      return <FaRegFileVideo fontSize={30} className="text-dark" />;
    } else if (type === jsonFile) {
      return <VscJson fontSize={30} className="text-warning" />;
    } else if (type === audioMpeg) {
      return <FaRegFileAudio fontSize={30} className="text-danger" />;
    } else if (type === presentation) {
      return <MdOutlineFilePresent fontSize={30} className="text-danger" />;
    }
  }

  return (
    <MeetingVideoDiv>
      {agendaFileCreateLoading ? (
        <MyButton className="add-file-btn">
          <CircularProgress
            size={20}
            sx={{
              color: green[500],
            }}
          />
        </MyButton>
      ) : (
        <label htmlFor="file" className="add-file-btn">
          <img
            className="form-btn-img"
            src={PlusIcon}
            alt="add-button"
            width={38}
            height={28}
          />

          <input
            type="file"
            id="file"
            style={{ display: "none" }}
            onChange={(e) => handleFileChange(e)}
            multiple
            accept="image/*,application/json,application/pdf,video/mp4,udio/mpeg,mage/jpeg,mage/png"
          />
        </label>
      )}

      <InnerFiles>
        {meetingFiles?.length > 0 ? (
          meetingFiles?.map((file) => {
            return(
              <FileDiv key={file.id}>
                <button
                  onClick={() =>
                    downloadFile({ fileId: file.id, name: file.name })
                  }
                >
                  <div>{fileTypeIcon(file.type)}</div>
                  <span>{file.name}</span>
                </button>
                <div className="btns-control">
                  {isLoading ? (
                    <MyButton className="btn delete-btn">
                      <CircularProgress
                        size={24}
                        sx={{
                          color: green[500],
                        }}
                      />
                    </MyButton>
                  ) : (
                    <MyButton
                      className="btn delete-btn"
                      onClick={() => deleteMeetingVideo(file.id)}
                    >
                      <img
                        src={DeleteIcon}
                        alt="DeleteIcon"
                        width={36}
                        height={36}
                      />
                    </MyButton>
                  )}
                </div>
              </FileDiv>
            )
          })
        ) : (
          <NoMessage>{t("userPage.filesNot")}</NoMessage>
        )}
      </InnerFiles>
    </MeetingVideoDiv>
  );
}
export default MeetingVideos;
